export const SET_PRODUCT_LIST = "setProductList"
export const SET_CURRENT_PAGE = "setCurrentPage"